import { TickDot } from './TickDot';

type LogoSize = 'sm' | 'md' | 'lg';
const SIZES: Record<LogoSize, { fontSize: number; dotSize: number; gap: number; ioSize: number }> = {
  sm: { fontSize: 20, dotSize: 8, gap: 2, ioSize: 8 },
  md: { fontSize: 36, dotSize: 15, gap: 3, ioSize: 12 },
  lg: { fontSize: 64, dotSize: 26, gap: 4, ioSize: 20 },
};

export function Logo({ size = 'md', dark = false }: { size?: LogoSize; dark?: boolean }) {
  const s = SIZES[size];
  const textColor = dark ? '#1A1A1A' : '#F5F5F0';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'baseline', color: textColor }}>
      <span style={{ fontFamily: 'Georgia, "Times New Roman", serif', fontStyle: 'italic', fontSize: s.fontSize, fontWeight: 400, marginRight: s.fontSize * 0.15 }}>
        make it
      </span>
      <span style={{ fontFamily: 'Inter, Helvetica, Arial, sans-serif', fontSize: s.fontSize, fontWeight: 500, letterSpacing: '-0.03em' }}>
        seo
      </span>
      <span style={{ display: 'inline-flex', alignSelf: 'center', marginLeft: s.gap, marginRight: s.gap }}>
        <TickDot size={s.dotSize} />
      </span>
      <span style={{ fontFamily: 'Inter, Helvetica, Arial, sans-serif', fontSize: s.ioSize, fontWeight: 300, color: dark ? '#888780' : '#888780' }}>
        io
      </span>
    </span>
  );
}
